import { get } from "lodash-es";
import React, { useContext } from "react";
import { useRequest } from "../../../abstracts";
import { LoaderWrapper, ManageTempMapLayout } from "../../../components";
import { CsplTable as Table } from "../../../components";
import {
  fileUploadForTempMapping,
  manageMapperStore,
  setManagePageLevelData,
} from "../../../contexts";
import { verifyMapService } from "../../../services";
import {
  getPathWithParam,
  managePayrollFormNames,
  MANAGE_PAYROLL_ROUTES,
  ROUTES,
} from "../../../utils";

const propertyNames = [
  "EmployeeClassifications",
  "Compensations",
  "Contributions",
  "PayrollLoans",
];
const VerifymappingContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const formName = managePayrollFormNames.UPLOAD_FILE;

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.PAYROLL,
    },
    {
      label: "Process",
      variant: "primary",
      type: "submit",
      onClick: () => {
        onFormSubmit();
      },
    },
  ];
  const columns = [
    {
      label: "Target Fields",
      columnName: "propertyName",
      className: "column-frequency",
    },
    {
      label: "Source Data",
      columnName: "propertyValue",
      className: "column-frequency",
    },
  ];

  const srcColumns = [
    {
      label: "Target Fields",
      columnName: "propertyName",
      className: "column-frequency-source",
    },
    {
      label: "Source Data",
      columnName: "propertyValue",
      className: "column-frequency",
    },
  ];

  const id = get(state, "profileId")
    ? parseInt(get(state, "profileId"))
    : get(state, "api.data.id");
  const { response, loading } = useRequest({
    method: verifyMapService,
    payload: id,
  });

  const onFormSubmit = () => {
    const { history } = props;
    const fileData = get(state, "api.fileuploadData.mappingConfiguration", []);
    let payload = {
      description: "",
      fileName: fileData.name,
      id: parseInt(fileData.id, 10),
    };
    fileUploadForTempMapping(payload, dispatch)
      .then((response) => {
        history.push(
          getPathWithParam({
            path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
          })
        );
      })
      .catch((error) => {
        throw error;
      });
    dispatch(
      setManagePageLevelData({
        formName: formName,
        fieldData: state,
      })
    );
  };

  return (
    <ManageTempMapLayout buttons={buttons}>
      <LoaderWrapper isLoading={loading}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {response?.map((source, index) => {
              if (propertyNames.includes(source.propertyName)) {
                return (
                  <>
                    <div
                      style={{
                        fontWeight: "bold",
                        padding: "10px",
                        borderBottom: "1px solid #ccc",
                        marginTop: "5px",
                      }}
                    >
                      <span className="ml-4">{source.propertyName}</span>
                    </div>
                    {source.propertyValue.map((e, i) => (
                      <Table.Tr
                        key={index}
                        style={{
                          borderBottom: "1px solid #ccc",
                          padding: "5px",
                          marginTop: "5px",
                        }}
                      >
                        {srcColumns.map((item, cellIndex) => {
                          return (
                            <Table.Td
                              key={cellIndex}
                              className={item.className}
                            >
                              {e[item.columnName]}
                            </Table.Td>
                          );
                        })}
                      </Table.Tr>
                    ))}
                  </>
                );
              }
              return (
                <Table.Tr
                  key={index}
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    marginTop: "5px",
                  }}
                >
                  {columns.map((item, cellIndex) => {
                    return (
                      <Table.Td key={cellIndex} className={item.className}>
                        {source[item.columnName]}
                      </Table.Td>
                    );
                  })}
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </LoaderWrapper>
    </ManageTempMapLayout>
  );
};

export default VerifymappingContainer;
